export default __webpack_public_path__ + "6fd687a89dac00b04142191b591f4216.svg";